import * as REDUX_ACTION from "../../../../services/redux/actions";

export const handleMark = (record, action, dispatch, messageApi, user) => {
  let updatedStatus;
  if (action === "active" && (record.status === 2 || record.status === 0)) {
    updatedStatus = 1;
  } else if (
    action === "suspended" &&
    (record.status === 1 || record.status === 0)
  ) {
    updatedStatus = 2;
  } else if (
    action === "terminated" &&
    (record.status === 1 || record.status === 2)
  ) {
    updatedStatus = 0;
  } else {
    console.error("Invalid action or status 1");
    return;
  }

  if (updatedStatus !== undefined) {
    const updatedItems = { ...record, status: updatedStatus }
    
    delete updatedItems.key; 
    delete updatedItems.picName;  

    const updatedRecord = {
      coid: record.coid,
      updatedBy: user.memid,
      items: updatedItems,
    };

    messageApi.open({
      type: "loading",
      content: "Updating Status...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_company.update_company_request(
        updatedRecord,
        ({ status }) => {
          messageApi.destroy()
        }
      )
    );
  } else {
    console.error("Invalid action or status 2");
  }
};

export const handleRequestStatus = (
  value,
  dispatch,
  messageApi,
  user,
  data
) => {
  messageApi.open({
    type: "loading",
    content: "Updating request status company...",
    duration: 0,
  });

  const reqStatusData = {
    coid: data.coid,
    updatedBy: user.memid,
    items: { ...data, isBlocked: value },
  };

  dispatch(
    REDUX_ACTION.v1_company.update_company_request(reqStatusData, 
      ({status}) => {
        messageApi.destroy()
      })
  );
};
